<template>
    <div>  
         <Header 
             :viewDeals="viewDeals" />
         
         <ModuleMenu 
             :moduleKey="$route.params.mid"
             :projectId="$route.params.pid"
             @quickViewDeals="viewDeals = !viewDeals" />
         
         <div class="container_width questionnaire_y_margin">
             <!-- <p v-html="details.questionnaire_stm"></p> -->
             <!-- <div style="text-align: center; color: red; font-size: 16px">Currently, there is an issue saving your data within the questionnaire. For now, please do not try to answer any questions ... please standby</div> -->
             <div id="questionnaire">
                 <ModuleQuestionnaire
                     v-if="readyToLoad"
                     :userId="authUser.id"
                     :moduleId="module_id"
                     :moduleKey="$route.params.mid"
                     :projectId="$route.params.pid"
                     :readonly="lock_questionnaire"
                     :introActive="details.intro_active"
                     :getCurrentProject="getCurrentProject"
                     :parentProjectId="parent_project_id"
                     :resolutionData="resolution_data"
                     :openQuestionnaire="openQuestionnaire"
                 />
             </div>
         </div>
    </div>
 </template>
 
 <script>
     import axios from 'axios'
     import Cookie from 'js-cookie'
     import appUrls from '../helpers/environment'
     import router from '../router'
     import { dynamicTitle } from './utilities';
 
     import Header from './Header'
     import ModuleMenu from './ModuleMenu'
     import ModuleQuestionnaire from './questionnaire_template/questionnaire'
 
     export default {
         name: 'Questionnaire',
         components: {
             Header,
             ModuleMenu,
             ModuleQuestionnaire
         },
 
         computed: {
             lock_questionnaire: function () {
                 const { module_key, questionnaire_locked, expired, can_write } = this.details;
 
                 // Lock if questionaire is not open, with an exception for buyer module
                 if (module_key !== 'buyer' && questionnaire_locked) {
                     return true;
                 }
 
                 // Lock if expired
                 if (expired) {
                     return true;
                 }
 
                 // Lock if user does not have write access
                 if (!can_write) {
                     return true;
                 }
             
                 return false;
             }
         },
 
         data () {
             return {
                 module_id: String,
                 parent_project_id: String,
                 resolution_data: Object,
                 readyToLoad: false,
                 progress_active: true,
                 details: [],
                 rowHeight: 24,
                 rows: 1,
                 viewDeals: false,
                 authUser: {
                     id: String,
                     group: String
                 }
             }
         },
 
         created () {
             document.title = dynamicTitle( 'Module Questionniare: ', this.$route.params )
         },
 
         mounted() {
             this.getCurrentProject();
         },
         methods: {
             checkUser: async function () {
                 try {
                     const user_check = await axios.get(`${appUrls.api}/api/user_check`, {
                         headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                     })
                 
                     if(user_check.data.outcome) {    
                         this.authUser.id = user_check.data.user_data.id
                         this.authUser.group = user_check.data.user_data.group
                         return true
                     } else {
                         console.log(user_check.data.message)
                         return false
                     }
                 } catch ( error ) {
                     console.log(error);
                 }
             },
 
             openQuestionnaire: function () {
                 console.log()
             },
 
             getCurrentProject: async function () {
                 try {
                     const user_check = await this.checkUser()
                 
                     if ( user_check ) {
                         const current_project = await axios.get(`${appUrls.api}/api/current_project/${this.$route.params.pid}/${this.authUser.id}`, {
                             headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                         })
 
                         // console.log(current_project.data.details)
                         if(current_project.data.outcome){
                             this.details = current_project.data.details;
                             this.parent_project_id = current_project.data.details.parent_project_id
                             this.module_id = this.details.module_id;
                             const user_creds = this.details.users != undefined ? this.details.users.find(user => user.user_id == this.authUser.id) : false
                             this.details.can_read = user_creds ? user_creds.read : true
                             this.details.can_write = user_creds ? user_creds.write : true
                             this.details.access_deliverables = user_creds ? user_creds.deliverables : true
                             this.details.expired = user_creds ? parseInt(user_creds.expires) == 0 || parseInt(user_creds.expires) > this.unixTimestamp() ? false : true : false
                             this.resolution_data = {}
                             if (this.parent_project_id) {
                               const parentProject = await axios.get(`${appUrls.api}/api/current_project/${this.parent_project_id}/${this.authUser.id}`, {
                                 headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                               })
                               this.resolution_data = parentProject.data.details.resolutions_data
                             }
                             
                             this.readyToLoad = true;
                         }
                     } else {
                         throw error
                     }
                 } catch ( error ) {
                     console.log(error);
                 }
             },
 
             unixTimestamp () {
                 const date = new Date().toGMTString();
                 const unixTimestamp = Date.parse(date) / 1000;
 
                 return unixTimestamp
             },
 
             navigate() {
                 router.go(-1);
             }
         }
     }
 </script>
 
 <!-- Add "scoped" attribute to limit CSS to this component only -->
 <style scoped>
     h1, h2 {
         font-weight: normal;
     }
 
     ul {
         list-style-type: none;
         padding: 0;
     }
 
     li {
         display: inline-block;
         margin: 0 10px;
     }
 
     #questionnaire {
         /* min-height: 30vh; */
         background-color: #FFFFFF;
         padding: 0;
     }
 
     .questionnaire_y_margin {
         margin-top: 60px;
         margin-bottom: 50px;
     }
     .questionnaire_title {
         font-family: 'SansationBold';
         color: #37383C; /* 5F6062 */ /* 37383c */
         font-size: 2.2rem;
     }
 
     #module_nav {
         background-color: transparent;
     }
     .section-wrapper {
         margin: 30px auto;
     }
 </style>
 



// WEBPACK FOOTER //
// src/components/ModuleQuestionnaire.vue